import SmartImage from './container'

export default SmartImage
